<template>
    <div v-if="simulation">
        <top-navbar :breadcrumb="$route.params.groupId != 0 ? groupBreadcrumb : cohortBreadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-lg-12">
                    <simulation
                        :registration="registration"
                        :simulation="simulation">
                    </simulation>
                    <tabs class="tabs"
                            tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper pb-3"
                            tabContentClasses="">

                        <tab-pane class="card mb-0" id="issues">
                            <span slot="title">
                                {{ $t('common.issues') }}
                            </span>
                            <issues
                                :registration="registration"
                                :simulation="simulation"
                                :edit="true"
                                role="pilot">
                            </issues>
                        </tab-pane>
                    </tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Simulation from './log/Simulation'
    import Issues from './session/Issues'

    export default {

        components: {
            Simulation, Issues
        },

        data() {
            return {
                registration: null,
                simulation: null,
            }
        },

        computed: {

            groupBreadcrumb() {
                const simRoute = this.$permissions.hasRight('dashboard.sessions.read')
                    ? '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/simulations/' + this.$route.params.simulationId + '/groups/' + this.$route.params.groupId
                    : null

                return [
                    {
                        name: this.registration.cohort.name,
                        route: '/astral/ui/dashboard/cohorts/' + this.registration.cohort.id
                    },
                    {
                        name: this.registration.degree.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/groups/' + this.$route.params.groupId
                    },
                    {
                        name: this.simulation.name,
                        route: simRoute
                    },
                    {
                        name: this.$t('common.issues'),
                    },
                ]
            },

            cohortBreadcrumb() {
                const simRoute = this.$permissions.hasRight('dashboard.sessions.read')
                    ? '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/simulations/' + this.$route.params.simulationId + '/cohorts/' + this.registration.cohort.id
                    : null

                return [
                    {
                        name: this.registration.cohort.name,
                        route: '/astral/ui/dashboard/cohorts/' + this.registration.cohort.id
                    },
                    {
                        name: this.registration.degree.name,
                        route: '/astral/ui/dashboard/registrations/' + this.$route.params.registrationId + '/cohorts/' + this.registration.cohort.id
                    },
                    {
                        name: this.simulation.name,
                        route: simRoute
                    },
                    {
                        name: this.$t('common.issues'),
                    },
                ]
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/registrations/'+to.params.registrationId+'/simulations/'+to.params.simulationId+'/data')
            .then(resp => {
                next(vm => {
                    vm.registration = resp.data.included.registration
                    vm.simulation = resp.data.included.simulation
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        }
    }
</script>
